import React from 'react';
import Lottie from 'react-lottie';
import Modal from '@common/modal';
import loading from '@graphic/loading.json';

import classnames from 'classnames/bind';
import styles from './loadingModal.module.scss';
const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: loading,
};

interface LoadingModalProps {
  visible: boolean;
}

const LoadingModal = ({ visible }: LoadingModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <div className={cx('lottieWrap')}>
          <Lottie options={options} />
        </div>
        <em className={cx('title')}>정보 확인중</em>
        <p className={cx('desc')}>잠시만 기다려 주세요.</p>
      </div>
    </Modal>
  );
};

export default LoadingModal;
